export function initGoogleAnalytics(userId) {
  if (!window.gtag || !userId) {
    return;
  }

  window.gtag('set', {
    user_id: userId,
  });
}

export function pushGoogleAnalytics4Event(eventName, eventParams) {
  if (!window.gtag) {
    return;
  }

  window.gtag('event', eventName, eventParams);
}
